import { useDispatch, useSelector } from 'react-redux';

import {
  useTakeoverExperimentContext,
  useVariantConfigurationContext,
} from 'modules/experiments/contexts';
import {
  getTakeoverCampaign,
  getTakeoverExperimentLocale,
} from 'modules/experiments/takeover/ducks/selectors';

import { useVariantTemplateValidationContext } from 'modules/experiments/contexts/VariantTemplateValidationContext';
import { updateExperimentLocale } from 'modules/experiments/takeover/ducks/actions';
import { useTemplateQueryContext } from 'modules/templateEditor/context/TemplateQueryContext';
import InStudioTemplateEditor, {
  ConsumingApp,
} from 'modules/templateEditor/integrations/InStudioTemplateEditing';
import { useTemplateTakeover } from 'modules/templateEditor/integrations/InStudioTemplateEditing/context';

export const TemplateEditorTakeover = () => {
  const dispatch = useDispatch();
  const {
    reFetch: { variantList: refetchVariantList },
  } = useTakeoverExperimentContext();
  const { selectedVariant } = useVariantConfigurationContext();
  const { id: campaignId, name: campaignName, messageMedium } = useSelector(getTakeoverCampaign);
  const currentLocale = useSelector(getTakeoverExperimentLocale);
  const { updateTemplateErrorsForAllVariantLocales } = useVariantTemplateValidationContext();
  const { refetch: refetchTemplate } = useTemplateQueryContext();

  const takeover = useTemplateTakeover();

  const handleClose = () => {
    refetchTemplate();
    refetchVariantList();
    updateTemplateErrorsForAllVariantLocales(selectedVariant?.id || 0);
    takeover.close();
  };

  const setCurrentLocale = (selectedLocale: string) => {
    dispatch(updateExperimentLocale(selectedLocale));
  };

  return (
    <>
      {takeover.isOpen ? (
        <InStudioTemplateEditor
          attachedTemplateId={selectedVariant?.id || 0}
          campaignId={campaignId}
          consumingApp={ConsumingApp.EXPERIMENT_TAKEOVER}
          templateId={selectedVariant?.id}
          title={campaignName}
          messageMedium={messageMedium}
          view={takeover.view}
          onViewChange={takeover.setView}
          onClose={handleClose}
          currentLocale={currentLocale}
          setCurrentLocale={setCurrentLocale}
        />
      ) : null}
    </>
  );
};
